// extracted by mini-css-extract-plugin
export default {"forma":"form_forma__XQA+G","forma__login":"form_forma__login__O6h-0"};